import React from "react";
import { Button } from "primereact/button";
import PageHeading from "../../components/PageHeading";

const NewUser = () => {
    const goToNetworkSite = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/search";
    }

    const pageHeader = (
        <PageHeading pageTitle="Welcome to Wallist!">
            <div className="block">
            </div>
        </PageHeading>
    );

    const openNew = () => {
        window.location.href = process.env.REACT_APP_NETWORK_SITE + "/company/create-profile";
    };

    return (
        <div>
            {pageHeader}
            <div className="layout-content">
                <div className="pages-panel card flex justify-content-center">
                    <div className="flex flex-column justify-content-center text-center" style={{ maxWidth: "1250px" }}>
                        <div className="text-2xl mb-2 font-semibold">Welcome to Wallist!</div>
                        <div className="text-lg mb-3">Where would you like to get started?</div>
                        <div className="grid">
                            <div className="col-12 md:col-6 p-5">
                                <div className="font-bold text-xl mb-2">
                                    Are you looking for help?
                                </div>
                                <div className="mb-2">Find top-rated landscapers, painters, plumbers, electricians, and other professionals in your area to help you!</div>
                                <div>
                                    <Button label="Find Service Providers" onClick={goToNetworkSite} icon="pi pi-search" />
                                </div>
                            </div>
                            <div className="col-12 md:col-6 border-500 border-top-1 md:border-top-none border-left-0 md:border-left-1 p-5">
                                <div className="font-bold text-xl mb-2">
                                    Are you a business owner?
                                </div>
                                <div className="mb-2">List your business profile on Wallist for free! You can also manage your customers, create quotes & invoices, and collect payments all through Wallist!</div>
                                <div>
                                    <Button label="Create My Company Profile" onClick={openNew} icon="pi pi-building" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewUser;
